import { useState, useEffect } from 'react'
import { XMarkIcon, DevicePhoneMobileIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { pwaService } from '../services/pwaService'

export default function PWAInstallPrompt() {
  const [isVisible, setIsVisible] = useState(false)
  const [isInstalling, setIsInstalling] = useState(false)
  const [installState, setInstallState] = useState(pwaService.getInstallState())

  useEffect(() => {
    const updateState = () => setInstallState(pwaService.getInstallState())

    const unsubscribe = pwaService.subscribe(updateState)
    updateState()

    // 3秒后显示安装提示（如果可安装且未安装）
    if (installState.isInstallable && !installState.isInstalled) {
      const timer = setTimeout(() => setIsVisible(true), 3000)
      return () => clearTimeout(timer)
    }

    return unsubscribe
  }, [installState.isInstallable, installState.isInstalled])

  const handleInstall = async () => {
    setIsInstalling(true)
    await pwaService.installPWA()
    setIsInstalling(false)
    setIsVisible(false)
  }

  const handleDismiss = () => {
    setIsVisible(false)
  }

  if (!isVisible || !installState.isInstallable || installState.isInstalled) {
    return null
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-sm mx-auto">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <DevicePhoneMobileIcon className="h-6 w-6 text-amber-600" />
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-900">
                安装LearnCore应用
              </h3>
              <p className="text-xs text-gray-500 mt-1">
                将应用安装到{installState.platform === 'ios' ? '主屏幕' : '桌面'}，享受更好的体验
              </p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-full"
          >
            <XMarkIcon className="h-4 w-4 text-gray-400" />
          </button>
        </div>

        <div className="mt-3 flex space-x-2">
          <button
            onClick={handleInstall}
            disabled={isInstalling}
            className="flex-1 bg-amber-600 hover:bg-amber-700 disabled:bg-amber-400 text-white text-sm px-3 py-2 rounded-md flex items-center justify-center transition-colors"
          >
            <ArrowDownTrayIcon className="h-4 w-4 mr-1" />
            {isInstalling ? '安装中...' : '安装'}
          </button>
          <button
            onClick={handleDismiss}
            className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            稍后
          </button>
        </div>
      </div>
    </div>
  )
}